import { CommonModule } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoPipe } from "@ngneat/transloco";
import type { Observable } from "rxjs";
import { TooltipDirective } from "src/app/core/directive";
import { ThemeService } from "src/app/core/service/theme-switcher.service";
import { Position } from "../../model/tooltipPosition";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-info-tooltip",
  standalone: true,
  imports: [TooltipDirective, CommonModule, SvgIconComponent, TranslocoPipe],
  templateUrl: "./info-tooltip.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./info-tooltip.component.scss",
})
export class InfoTooltipComponent {
  @Input() public iconPosition: Position = "flex";
  @Input() public variant: "default" | "circle" = "default";
  public isLightTheme$: Observable<boolean> = this._themeService.isLightTheme$;

  constructor(private _themeService: ThemeService) {}

  public isTooltipVisible = false;

  public handleTooltipVisibilityChange(isVisible: boolean): void {
    this.isTooltipVisible = isVisible;
  }
}
